import { Popup } from "linkdrop-ui"
import styled from "styled-components"
import {
  TextArea,
  Button
} from 'components/common'


export const PopupStyled = styled(Popup)`

`

export const TextAreaStyled = styled(TextArea)`
`

export const ButtonStyled = styled(Button)`
  width: 100%;
`